// Studies List Filter Constants

export interface FilterOption {
  value: string;
  label: string;
}

// Client Filter Options
export const CLIENT_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
];

// Grader Filter Options
export const GRADER_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
];

// Status Filter Options
export const STUDY_STATUS_OPTIONS: FilterOption[] = [
  { value: '', label: 'All' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'ASSIGNED', label: 'Assigned' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'PENDING', label: 'Pending' },
];

// Status values
export const STUDY_STATUS = {
  ALL: '',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
} as const;

// Status display labels
export const STUDY_STATUS_LABELS = {
  [STUDY_STATUS.ALL]: 'All',
  [STUDY_STATUS.IN_PROGRESS]: 'In Progress',
  [STUDY_STATUS.ASSIGNED]: 'Assigned',
  [STUDY_STATUS.COMPLETED]: 'Completed',
  [STUDY_STATUS.PENDING]: 'Pending',
} as const;
